import BaseAPI from '@/apis/base/baseApi';

class BranchAPI extends BaseAPI {
  apiName = 'Business';
  controllerName = 'Branches';

  updateInactive(companyCode, branchID, inactive, loading = true) {
    const query = `?companyCode=${encodeURIComponent(companyCode)}&branchID=${encodeURIComponent(branchID)}&inactive=${Boolean(inactive)}`;
    return this.putAsync({ url: `${this.getAPIUrl()}/update-inactive${query}` }, loading);
  }

  /**
   * Description: Cập nhật merchant_id cho 1 branch — BE ghi tuần tự
   * request (License hub) → branch (License hub) → dbo.DBOption tenant DB (OptionID='MerchantID').
   * @param {string} companyCode Mã công ty (bắt buộc)
   * @param {string} branchID    Branch id GUID (bắt buộc)
   * @param {string} merchantId  Giá trị mới — rỗng = xóa merchant
   * Created by: lvduy — 11/09/2026
   */
  updateMerchantId(companyCode, branchID, merchantId) {
    const query = `?companyCode=${encodeURIComponent(companyCode)}&branchID=${encodeURIComponent(branchID)}&merchantId=${encodeURIComponent(merchantId || '')}`;
    return this.putAsync({ url: `${this.getAPIUrl()}/update-merchant-id${query}` }, false);
  }

  /**
   * Description: Lấy thông tin license detail (1 branch) qua Proc_GetLicenseInfo
   * — join company + branch + package_license + national.
   * @param {string} companyCode Mã công ty (bắt buộc)
   * @param {string} branchId   Branch id (rỗng → proc tự chọn branch root/dummy/mới nhất)
   * Created by: lvduy — 09/09/2026
   */
  getLicenseInfo(companyCode, branchId, loading = true) {
    const query = `?branchId=${encodeURIComponent(branchId || '')}`;
    return this.getAsync({ url: `${this.getAPIUrl()}/detail/${encodeURIComponent(companyCode)}${query}` }, loading);
  }
}

export default new BranchAPI();
